module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN332_175331120.eea00e1c.png";